module.exports = __webpack_public_path__ + "static/media/eddie-14.8bd0ccfa.png";